import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { CRS_CONSTANTS } from '../../pages/constants/crsContants';
import {
  deleteRiskIndicatorThresholdData,
  DELETE_CRS_RISK_INDICATOR_THRESHOLD,
  getRiskIndicatorsData,
  getRiskIndicatorStaticProperties,
  getRiskIndicatorThresholdsData,
  GET_CRS_RISK_INDICATORS,
  GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES,
  GET_CRS_RISK_INDICATOR_THRESHOLDS,
  putRiskIndicatorThresholdData,
  PUT_CRS_RISK_INDICATOR_THRESHOLD,
  updateRiskIndicatorThresholdData,
  UPDATE_CRS_RISK_INDICATOR_THRESHOLD,
  postRiskIndicatorTriggerScoring,
  POST_RISK_INDICATOR_TRIGGER
} from '../../redux/actions/crs/crsRiskIndicator';
import * as api from '../../services/crs/crsRiskIndicator';

const { GET_FAILURE_DATA, GET_SUCCESS_DATA } = CRS_CONSTANTS;

const networkLayerObject = new api.NetworkLayer();

// Get Risk Indicators
function* getRiskIndicatorsWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.getRiskIndicatorsAPI,
      payload
    );
    yield put(getRiskIndicatorsData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getRiskIndicatorsData(error, GET_FAILURE_DATA));
  }
}

export function* watchGetRiskIndicators() {
  yield takeEvery(GET_CRS_RISK_INDICATORS, function* ({ payload }) {
    yield fork(getRiskIndicatorsWorker, payload);
  });
}

// Get Risk Indicator Thresholds
function* getRiskIndicatorThresholdsWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.getRiskIndicatorThresholdsAPI,
      payload
    );
    yield put(getRiskIndicatorThresholdsData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getRiskIndicatorThresholdsData(error, GET_FAILURE_DATA));
  }
}

export function* watchGetRiskIndicatorThresholds() {
  yield takeEvery(GET_CRS_RISK_INDICATOR_THRESHOLDS, function* ({ payload }) {
    yield fork(getRiskIndicatorThresholdsWorker, payload);
  });
}

// Put Risk Indicator Threshold
function* putRiskIndicatorThresholdWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.putRiskIndicatorThresholdAPI,
      payload
    );
    yield put(putRiskIndicatorThresholdData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(putRiskIndicatorThresholdData(error, GET_FAILURE_DATA));
  }
}

export function* watchPutRiskIndicatorThreshold() {
  yield takeEvery(PUT_CRS_RISK_INDICATOR_THRESHOLD, function* ({ payload }) {
    yield fork(putRiskIndicatorThresholdWorker, payload);
  });
}

// Delete Risk Indicator Threshold
function* deleteRiskIndicatorThresholdWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.deleteRiskIndicatorThresholdAPI,
      payload
    );
    yield put(deleteRiskIndicatorThresholdData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(deleteRiskIndicatorThresholdData(error, GET_FAILURE_DATA));
  }
}

export function* watchDeleteRiskIndicatorThreshold() {
  yield takeEvery(DELETE_CRS_RISK_INDICATOR_THRESHOLD, function* ({ payload }) {
    yield fork(deleteRiskIndicatorThresholdWorker, payload);
  });
}

// Update Risk Indicator Threshold
function* updateRiskIndicatorThresholdWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.updateRiskIndicatorThresholdAPI,
      payload
    );
    yield put(updateRiskIndicatorThresholdData(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(updateRiskIndicatorThresholdData(error, GET_FAILURE_DATA));
  }
}

// Post Risk Indicator Trigger
function* postRiskIndicatorTriggerWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.postRiskIndicatorTriggerAPI,
      payload
    );
    yield put(postRiskIndicatorTriggerScoring(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(postRiskIndicatorTriggerScoring(error, GET_FAILURE_DATA));
  }
}

export function* watchPostRiskIndicatorTrigger() {
  yield takeEvery(POST_RISK_INDICATOR_TRIGGER, function* ({ payload }) {
    yield fork(postRiskIndicatorTriggerWorker, payload);
  });
}

export function* watchUpdateRiskIndicatorThreshold() {
  yield takeEvery(UPDATE_CRS_RISK_INDICATOR_THRESHOLD, function* ({ payload }) {
    yield fork(updateRiskIndicatorThresholdWorker, payload);
  });
}

// Get Risk Indicator Static Properties
function* getRiskIndicatorStaticPropertiesWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.getRiskIndicatorStaticPropertiesAPI,
      payload
    );
    yield put(getRiskIndicatorStaticProperties(response, GET_SUCCESS_DATA));
  } catch (error) {
    yield put(getRiskIndicatorStaticProperties(error, GET_FAILURE_DATA));
  }
}

export function* watchGetRiskIndicatorStaticProperties() {
  yield takeEvery(
    GET_CRS_RISK_INDICATOR_STATIC_PROPERTIES,
    function* ({ payload }) {
      yield fork(getRiskIndicatorStaticPropertiesWorker, payload);
    }
  );
}
